import { buildFTCDisclosures, type FTCDisclosure } from "@expert/contentful";
import { Button, Checkbox, Divider, Flex, Text } from "@mantine/core";

export const DisclosuresMap = ({
    requiresNyDisclosures,
    FTCDisclosures,
}: {
    requiresNyDisclosures: boolean;
    FTCDisclosures?: FTCDisclosure;
}) => {
    if (!FTCDisclosures) {
        return <Flex>{`There are currently no disclosures available for this product`}</Flex>;
    } else {
        const disclosures = buildFTCDisclosures(FTCDisclosures);
        return (
            <Flex gap="1.5rem" direction="column" w="100%">
                <Text size="lg">Enrollment and cancelation</Text>
                <Checkbox disabled label={<Text>{disclosures.checkbox1text}</Text>} />
                <Text size="lg">Important plan information</Text>
                <Text size="sm">{disclosures.mainText}</Text>
                {requiresNyDisclosures && <Text size="sm">{disclosures.nyAddendum}</Text>}
                <Checkbox disabled label={<Text>{disclosures.checkbox2text}</Text>} />
                <Divider />
                <Flex justify="space-between">
                    <Button disabled w="25%">
                        Decline
                    </Button>
                    <Button disabled w="70%">
                        Sign up
                    </Button>
                </Flex>
            </Flex>
        );
    }
};
